export default __webpack_public_path__ + "static/media/758.46736200.gif";